import {
  Box,
  Paper,
  Title,
  createStyles,
  Modal,
  Button,
  Text,
  SimpleGrid,
  Card,
} from "@mantine/core";

import headIcon from "../../assets/img/insuranceHeadingLogo.svg";
import pverifyIcon from "../../assets/img/pverify-946.png";
import availityIcon from "../../assets/img/availity-2700.png";

import { useNavigate } from "react-router-dom";
import { forwardRef, useEffect, useState } from "react";
import { useMedplum } from "@medplum/react";
import { showNotification } from "@mantine/notifications";
import { IconArrowRight } from "@tabler/icons-react";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  loader: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  card: {
    "&:hover": {
      boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
    },
  },
  group: { justifyContent: "space-between", height: "30px", width: "100%" },
  box1: { display: "flex", flexDirection: "column" },
  Boxtitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  cardHeading: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    alignItems: "center",
    width: "100%",
    marginBottom: "16px",
  },
  title: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  breadCrumbs: {
    marginBottom: "50px",
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
  },
  iconBox: {
    height: "32px",
    width: "32px",
    borderRadius: 4,
    padding: 8,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#9DCDF3",
    gap: 8,
  },
  cardDesc: {
    gap: 10,
  },
  supportedCon: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    gap: "8px",
  },
  suppLogoBox: {
    height: "40px",
    width: "64px",
    paddingInline: "12px",
    paddingTop: "8px",
    borderRadius: "1.85px",
    borderStyle: "solid",
    borderWidth: "0.23px",
    borderColor: "#BEDEF8",
  },
  suppLogoPverify: {
    height: "22px",
    width: "39px",
  },
  suppLogoAvaility: {
    height: "16px",
    width: "40px",
  },
  buttonBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "right",
    alignItems: "bottom",
  },
  modalBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    gap: "10px",
  },
  modalLogoBox: {
    height: "130px",
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "8px",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "#BEDEF8",
    marginBottom: "12px",
    cursor: "pointer",
    "&:hover": {
      borderColor: "#7ec0f7",
      borderWidth: "2px",
    },
  },
  modalLogoPverify: {
    height: "80px",
    width: "120px",
  },
  modalLogoAvaility: {
    height: "62px",
    width: "140px",
  },
}));

export const Insurance = () => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [currOptionRoute, setCurrOptionRoute] = useState("");

  const allowedOptions = ["eligibility", "Prior Authorization", 'eligibility-claimdetails'];

  const insuranceOptions = [
    {
      title: "Eligibility Summary",
      desc: "Easy and discrete eligibility information, including  key benefits information such as surgical benefits, DME benefits, or PT benefits.",
      supported: ["pverify", "availity"],
      nav: "eligibility",
    },
    {
      title: "Prior Authorization",
      desc: "Get Authorization for your upcoming services to make the claims process easier and faster.",
      supported: ["availity"],
      nav: "prior-auth",
    },
    {
      title: "EDI Claims",
      desc: "Create and file claims for any of your services.",
      supported: [ 'pverify',"availity"],
      nav: "claims",
    },
    {
      title: "Care Cost Estimation",
      desc: "Analyze your services and cost incurred in your care. And Estimate your costs based on your service history.",
      supported: ["availity"],
      nav: "carecost",
    },
    
  ];

  const handleNavigate = (service: string) => {
    if (currOptionRoute)
      navigate(`/admin/insurance/${currOptionRoute}?service=${service}`);
  };

  return (
    <>
      <Modal
        opened={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        size="md"
        title="Select Service"
        withCloseButton={true}
        closeOnEscape={true}
        closeOnClickOutside={true}
      >
        <Box className={classes.modalBox}>
          <Box
            className={classes.modalLogoBox}
            onClick={() => {
              if (currOptionRoute === "prior-auth" || currOptionRoute === "eligibility-claimdetails") {
                showNotification({
                  color: "orange",
                  message: "Service not supported! Work in progress",
                  autoClose: true,
                });
                return;
              } else {
                handleNavigate("pverify");
              }
            }}
          >
            <img className={classes.modalLogoPverify} src={pverifyIcon} />
          </Box>
          <Box
            className={classes.modalLogoBox}
            onClick={() => handleNavigate("availity")}
          >
            <img className={classes.modalLogoAvaility} src={availityIcon} />
          </Box>
        </Box>
      </Modal>
      <Paper className={classes.default}>
        <Box sx={{}}>
          <Box className={classes.box1}>
            <Box>
              <Box className={classes.Boxtitle}>
                <Title className={classes.title}>Insurance</Title>
              </Box>
            </Box>
          </Box>
          <SimpleGrid cols={2} spacing={24} mt="xl" verticalSpacing="xl">
            {insuranceOptions.map((ins, i) => (
              <Card
                padding="lg"
                radius="md"
                withBorder
                className={classes.card}
              >
                <Box className={classes.cardHeading}>
                  <Box className={classes.iconBox} mr={12}>
                    <img style={{ verticalAlign: "top" }} src={headIcon} />
                  </Box>
                  <Title order={6} color="#262930" weight={600} size={14}>
                    {ins.title}
                  </Title>
                </Box>
                <Text
                  weight={400}
                  size={14}
                  color="#474E5B"
                  lh={"22px"}
                  mb={16}
                  className={classes.cardDesc}
                >
                  {ins.desc}
                </Text>
                <Text
                  weight={400}
                  size={14}
                  color="#474E5B"
                  lh={"22px"}
                  mb={8}
                  className={classes.cardDesc}
                >
                  Supported
                </Text>
                <SimpleGrid cols={2} spacing={"xl"}>
                  <Box className={classes.supportedCon}>
                    {ins.supported.includes("pverify") && (
                      <Box className={classes.suppLogoBox}>
                        <img
                          className={classes.suppLogoPverify}
                          src={pverifyIcon}
                        />
                      </Box>
                    )}
                    {ins.supported.includes("availity") && (
                      <Box className={classes.suppLogoBox}>
                        <img
                          className={classes.suppLogoAvaility}
                          src={availityIcon}
                        />
                      </Box>
                    )}
                  </Box>
                  <Box className={classes.buttonBox}>
                    <Button
                      variant="outline"
                      w={"max-content"}
                      // className={classes.proceedBtn}
                      onClick={() => {
                        const { title, nav } = ins; // Destructure properties for easier access

                        // Check if the title matches "Prior Authorization"
                        if (title === "Prior Authorization") {
                          setModalOpen(true);
                          setCurrOptionRoute(nav);

                          return; // Early return to exit the function
                        }

                        if (title === "EDI Claims") {
                          setModalOpen(true);
                          setCurrOptionRoute(nav);

                          return; // Early return to exit the function
                        }

                        // Check if the navigation option is allowed
                        if (allowedOptions.includes(nav)) {
                          setModalOpen(true);
                          setCurrOptionRoute(nav);
                          return; // Early return to exit the function
                        }

                        // Show notification for unsupported services
                        showNotification({
                          color: "orange",
                          message: "Service not supported! Work in progress",
                          autoClose: true,
                        });
                      }}
                    >
                      <Text mt={1} size={"14px"} weight={500}>
                        Proceed
                      </Text>
                      <IconArrowRight
                        style={{ marginLeft: "8px" }}
                        size={"18px"}
                      />
                    </Button>
                  </Box>
                </SimpleGrid>
              </Card>
            ))}
          </SimpleGrid>
        </Box>
      </Paper>
    </>
  );
};
